import {
  type HistoryOptions,
  parseAsString,
  useQueryStates,
} from '@vrplatform/query-params';
import { removeDrawerStateFromUrl } from '../../utils';

export function useBankRecordDetailDrawer() {
  const [opts, set] = useQueryStates({
    bankRecord: parseAsString,
  });

  return {
    opened: !!opts.bankRecord,
    open: (id: string, type?: HistoryOptions) => {
      removeDrawerStateFromUrl();
      set(
        { bankRecord: id },
        {
          history: type || 'push',
        }
      );
    },
    close: () => set(null),
    bankRecordId: opts.bankRecord,
  };
}
